import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface FadeInOnScrollProps {
  children: ReactNode;
  delay?: number;
  /** Pixel distance the child starts from its rest position */
  offset?: number;
  /** Intersection margin — negative starts the animation before fully visible */
  rootMargin?: string;
  className?: string;
  /** Re-animate every time it enters the viewport */
  once?: boolean;
}

/**
 * Scroll-triggered fade + rise. Mirrors MosaicCard's built-in reveal, but
 * exposed as a component for non-mosaic sections (hero subtitles, text
 * blocks, standalone CTAs).
 *
 * Respects prefers-reduced-motion through the global override in globals.css.
 */
export function FadeInOnScroll({
  children,
  delay = 0,
  offset = 24,
  rootMargin = '-60px',
  className,
  once = true,
}: FadeInOnScrollProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: offset }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: rootMargin }}
      transition={{ duration: 0.5, ease: 'easeOut', delay }}
    >
      {children}
    </motion.div>
  );
}
